import { treaty } from "@elysiajs/eden";
import type { App as ElysiaApp } from "ghost-server";

const isProd = process.env.NODE_ENV === "production";

const baseUrl =
	import.meta.env?.BUN_PUBLIC_SERVER_URL ??
	(isProd && typeof window !== "undefined" ? `${window.location.origin}/api` : "localhost:3000");

export const api = treaty<ElysiaApp>(baseUrl, {
	fetch: { credentials: "include" },
});
